import styles from './RegModeMnp.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setSlider} from "../../Reducer/GlobalReducer";
import React, {useEffect, useState} from "react";
import SelectNumber from "../SelectNumber/SelectNumber";
import RuPersonalData from "../PersonalData/PersonalData";
import DeliveryItem from "../DeliveryItem/DeliveryItem";
import Payment, {PaymentInt} from "../Payment/Payment";
import PersonalDataMnp from "../PersonalDataMnp/PersonalDataMnp";
import RuPersonalDataMnp from "../PersonalDataMnp/PersonalDataMnp";
import ClientInfoItem from "../ClientInfoItem/ClientInfoItem";
import Coupon from "../Coupon/Coupon";
import {useNavigate} from "react-router-dom";

interface RegModeOnePropsInt
{
    parentWidth?:number
}

export default function RegModeMnp({parentWidth}:RegModeOnePropsInt){
    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider.dataCardItem
    })
    const navigate = useNavigate()
    const [showDetails, setShowDetails] = useState(true)

    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const [stage, setStage] =useState(0)
    const [error,setError] = useState("")
    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })


    useEffect(()=>{
        if(prefDomain?.skipCoupon || !dataCardItem?.useCoupon) setStage(1)
    },[prefDomain, dataCardItem])

    const stagePersonalDataResult = () =>{

        setStage(2)
    }
    const stageDeliveryResult = ()=>{
        setStage(3)
        setShowDetails(true)
    }
    const stagePaymentResult = (data: PaymentInt) =>{
        setStage(4)
    }
    const stageCouponResult = ()=>{
        setStage(1)
    }

    if(stage === 4) return (
        <ClientInfoItem/>
    )


    //const useCoupon = !!dataCardItem?.useCoupon && !prefDomain?.skipCoupon

    const xPrice = orderData?.tarifData?.newPrice !== undefined ? orderData?.tarifData?.newPrice : orderData?.tarifData?.price

    let actPrice =   dataCardItem?.bundleOne?.actCost ? dataCardItem?.bundleOne?.actCost + 100 : 100
    if(orderData?.mnpData?.sameOper ) actPrice = 0

    return(
        <div className={[styles.orderCont ,styles.orderContBorder].join(' ')} >

            <div className={styles.orderOneStageCont}>

                {showDetails &&
                    <>
                        <div className={styles.orderLine}>
                            <div >Режим :</div>
                            <span className={styles.span}>Переход со своим номером</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Оператор :</div>
                            <span className={styles.span}>{orderData?.tarifData?.operName}</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Ваш тариф :</div>
                            <span className={styles.span}>{orderData?.tarifData?.name}</span>
                        </div>

                        <div className={styles.orderLine}>
                            <div >Регион подключения :</div>
                            <span className={styles.span}>{orderData?.regionData?.macroRegionName?.replace(/Регион :/ui,'')}</span>
                        </div>

                        {orderData?.couponId &&
                            <div className={styles.orderLine}>
                                <div >Примененный купон</div>
                                <span className={[styles.span, styles.blueColor].join(' ')}>{orderData?.couponId}</span>
                            </div>
                        }


                        <div className={styles.orderLine}>
                            <div >Стоимость подключения на тариф :</div>
                            <span className={[styles.redColor,styles.span].join(' ')}>{xPrice + " руб."}</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Номер для перехода :</div>
                            <span className={styles.span}>{orderData?.mnpData?.ctn}</span>
                        </div>

                        { actPrice > 0 &&
                            <div className={styles.orderWar}>
                                <div>Внимание, оператор {orderData?.tarifData?.operName?.toLowerCase()} взимает <span>единоразовую</span> плату за активацию и процедуру переноса номера в размере {actPrice + " руб."}</div>
                            </div>

                        }


                        { stage>1 &&
                            <div className={styles.orderLine}>
                                <div >Персональные данные :</div>
                                <span className={styles.span}>ОК</span>
                            </div>
                        }
                        { stage>2 &&
                            <div className={styles.orderLine}>
                                <div >Стоимость доставки :</div>
                                <span className={styles.span}>{orderData?.deliveryData?.price + " руб."}</span>
                            </div>
                        }
                        { stage>3 &&
                            <div className={styles.orderLine}>
                                <div >Платеж :</div>
                                <span className={styles.span}>{orderData?.paymentData?.amount + " руб."}</span>
                            </div>
                        }
                        { stage>3 &&
                            <div className={styles.orderLine}>
                                <div >Ваш номер заказа :</div>
                                <span className={styles.span}>{orderData?.orderId}</span>
                            </div>
                        }
                    </>
                }









            </div>

            {stage===0 &&

                <div className={styles.btnCont}>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                dispatch(setSlider({sliderMode:0}))
                                navigate('/')
                            }}
                    >Отменить</button>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                setShowDetails(false)
                                setStage(1)
                            }} // на персональные данные
                    >Продолжить</button>

                </div>

            }



            {stage === 1 &&
                <RuPersonalDataMnp cbExecute={stagePersonalDataResult}/>

            }
            {stage === 2 &&
                <DeliveryItem cbExecute={stageDeliveryResult} contWidth={ parentWidth ? parentWidth : 0 } />

            }
            {stage === 3 &&
                <Payment cbExecute={stagePaymentResult}></Payment>

            }


            {stage === -1 &&
                <div>{error}</div>
            }

        </div>
    )
}